// extracted by mini-css-extract-plugin
export default {"container":"style_container__PkvNj","title":"style_title__WyotB","contents":"style_contents__XjURv","link":"style_link__CtSzC","points":"style_points__z7T9Z"};